import React from 'react';

const RecordingStatusOverlay = ({ isRecording, phrase, signs = [], variation }) => {
    if (!isRecording || !phrase) return null;

    return (
        <div className="recording-status-indicator">
            <div className="recording-status-content">
                <div className="recording-gesture"><strong>PHRASE:</strong> {phrase}</div>
                {variation && (
                    <div className="recording-variation"><strong>VARIATION:</strong> {variation}</div>
                )}
                {signs.length > 0 && (
                    <div className="recording-instruction"><strong>SIGNS:</strong> {signs.join(', ')}</div>
                )}
            </div>
        </div>
    );
};

export default React.memo(RecordingStatusOverlay);
